import { Component, Vue } from "vue-property-decorator";
import { resellerOrderCheckoutStore as store } from "./store";
import http from "@/services/Http";
import * as Models from "./models";
import { deliveriesStore } from "@/store/DeliveriesModule";
import { DeliveryModel} from "../../models/deliveryModel";
import { EventBus } from "../../events";

import PaymentWidget from "./components/PaymentWidget";
import ResellerMap from "./components/ResellerMap";
import ResellerProductList from "./components/ResellerProductList";

@Component({
    components: {
        PaymentWidget,
        ResellerMap,
        ResellerProductList
  }
})
export default class ResellerOrderCheckout extends Vue {
    protected vm: Models.ResellerOrderCheckoutModel = {} as Models.ResellerOrderCheckoutModel;
    protected created() {
        http.get<Models.ResellerOrderCheckoutModel>(store.apiUrl + "?postalRegion=" + (deliveriesStore.deliveries as DeliveryModel).postalRegion)
             .then(model => {
                this.vm = model;
                this.$nextTick(() => {
                    EventBus.$emit("initMapSearch", (deliveriesStore.deliveries as DeliveryModel).postalRegion);
                });
                this.resellers = model.resellers;
                this.orderInfo = model.orderInfo;
             });
    }

    set resellers(resellers: Models.Reseller[]) {
        store.setResellers(resellers);
    }

    get resellers() {
        return store.resellers;
    }

    get orderInfo() {
        return store.orderInfo;
    }

    set orderInfo(products: Models.OrderInfo) {
        store.setOrderInfo(products);
    }

    get selectedReseller() {
        return store.selectedReseller;
    }

    get paymentWidget() {
        return store.paymentWidget;
    }

    get paymentError() {
        return store.paymentError;
    }

    get showPaymentWidget(): boolean {
        if (this.paymentWidget && !this.paymentError && this.selectedReseller.id) {
            return true;
        }
        return false;
    }

    get showMap() {
        return this.resellers.length > 0;
    }

    get showOrderInfo(): boolean {
        if (this.orderInfo &&
            ((store.orderInfo.products && store.orderInfo.products.length) ||
            (store.orderInfo.bundles && store.orderInfo.products.length))) {
            return true;
        }
        return false;
    }
}
